// Author THQ
// Date 2025-04-03 17:05:39

class PpeApplyRecordHistory {
    constructor({
                    id = null,
                    flowId = '',
                    inventoryId = '',
                    changeType = '',
                    itemType = '',
                    itemName = '',
                    itemModel = '',
                    itemUnit = '',
                    originalQuantity = '',
                    applyQuantity = '',
                    applicantNumber = '',
                    applicantName = '',
                    applyDept = '',
                    applyDeptManagerNumber = '',
                    applyDeptManagerName = '',
                    applyReason = '',
                    lastApplyDate = '',
                    applyStartDate = '',
                    applyEndDate = '',
                    applyAttachments = '',
                    applyRemark = '',
                    applyAttachmentsList = ''
                }
                    = {}) {
        this.id = id;
        this.flowId = flowId;
        this.inventoryId = inventoryId;
        this.changeType = changeType;
        this.itemType = itemType;
        this.itemName = itemName;
        this.itemModel = itemModel;
        this.itemUnit = itemUnit;
        this.originalQuantity = originalQuantity;
        this.applyQuantity = applyQuantity;
        this.applicantNumber = applicantNumber;
        this.applicantName = applicantName;
        this.applyDept = applyDept;
        this.applyDeptManagerNumber = applyDeptManagerNumber;
        this.applyDeptManagerName = applyDeptManagerName;
        this.applyReason = applyReason;
        this.lastApplyDate = lastApplyDate;
        this.applyStartDate = applyStartDate;
        this.applyEndDate = applyEndDate;
        this.applyAttachments = applyAttachments;
        this.applyRemark = applyRemark;
        this.applyAttachmentsList = applyAttachmentsList;
    }
}

function newEntity() {
    return new PpeApplyRecordHistory();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inventoryId',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.inventoryId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'changeType',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.changeType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string',
                options: [
                    {value: '1', text: '领用'},
                    {value: '2', text: '借用'},
                    {value: '3', text: '归还'},
                    {value: '4', text: '报废'},
                    {value: '5', text: '期初入库'},
                    {value: '6', text: '入库'},
                    {value: '7', text: '出库'}
                ],
                customClass: (row) => {
                    //超过一天的的变红
                    if (row.changeType === 4) {
                        return "text-danger font-weight-bold"
                    } else if (row.changeType === 1) {
                        return "text-success font-weight-bold"
                    }
                },
            }
        },
        {
            key: 'itemType',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.itemType',
            sortable: true,
            form: {
                type: 'dictEnumSelect',
                modalMultiSelectedType: 'string'
                , entity: 'ppe_material_type'
            }
        },
        {
            key: 'itemName',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.itemName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemModel',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.itemModel',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemUnit',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.itemUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'originalQuantity',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.originalQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applyQuantity',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.applyQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applicantNumber',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.applicantNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applicantName',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.applicantName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applyDept',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.applyDept',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applyDeptManagerNumber',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.applyDeptManagerNumber',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applyDeptManagerName',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.applyDeptManagerName',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applyReason',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.applyReason',
            sortable: true,
            form: {
                type: 'dictEnumSelect',
                modalMultiSelectedType: 'string'
                , entity: 'ppe_apply_reason'
            }
        },
        {
            key: 'lastApplyDate',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.lastApplyDate',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applyStartDate',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.applyStartDate',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applyEndDate',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.applyEndDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applyAttachmentsList',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.applyAttachmentsList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applyRemark',
            label: 'label.em.ppe.ppeApplyRecordHistory.grid.applyRemark',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    flowIdFilter: '',
    inventoryIdFilter: '',
    changeTypeFilter: '',
    itemTypeFilter: '',
    itemNameFilter: '',
    itemModelFilter: '',
    applicantNumberFilter: '',
    applicantNameFilter: '',
    applyDeptFilter: '',
    applyDeptManagerNumberFilter: '',
    applyDeptManagerNameFilter: '',
    applyReasonFilter: '',
    lastApplyDateRteFilter: '',
    lastApplyDateLteFilter: '',
    applyStartDateRteFilter: '',
    applyStartDateLteFilter: '',
    applyEndDateRteFilter: '',
    applyEndDateLteFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'inventoryIdFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.inventoryId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'ppeInventory'
            , correspondingField: 'id'
        }
    },
    {
        key: 'changeTypeFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.changeType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '领用'},
                {value: '2', text: '借用'},
                {value: '3', text: '归还'},
                {value: '4', text: '报废'},
                {value: '5', text: '期初入库'},
                {value: '6', text: '入库'},
                {value: '7', text: '出库'}
            ]
        }
    },
    {
        key: 'itemTypeFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.itemType',
        disabled: false,
        form: {
            type: 'dictEnumSelect',
            modalMultiSelectedType: 'string'
            , entity: 'ppe_material_type'
        }
    },
    {
        key: 'itemNameFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.itemName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemModelFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.itemModel',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applicantNumberFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.applicantNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applicantNameFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.applicantName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyDeptFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.applyDept',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyReasonFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.applyReason',
        disabled: false,
        form: {
            type: 'dictEnumSelect',
            modalMultiSelectedType: 'string'
            , entity: 'ppe_apply_reason'
        }
    },
    {
        key: 'lastApplyDateRteFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.lastApplyDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastApplyDateLteFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.lastApplyDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyStartDateRteFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.applyStartDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyStartDateLteFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.applyStartDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyEndDateRteFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.applyEndDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyEndDateLteFilter',
        label: 'label.em.ppe.ppeApplyRecordHistory.filter.applyEndDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'flowId',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.flowId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'ppeApplyRecord'
            , correspondingField: 'id'
        }
    },
    {
        key: 'inventoryId',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.inventoryId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'ppeInventory'
            , correspondingField: 'id'
        }
    },
    {
        key: 'changeType',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.changeType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '领用'},
                {value: '2', text: '借用'},
                {value: '3', text: '归还'},
                {value: '4', text: '报废'},
                {value: '5', text: '期初入库'},
                {value: '6', text: '入库'},
                {value: '7', text: '出库'}
            ]
        }
    },
    {
        key: 'itemType',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.itemType',
        sortable: true,
        disabled: false,
        form: {
            type: 'dictEnumSelect',
            modalMultiSelectedType: 'string'
            , entity: 'ppe_material_type'
        }
    },
    {
        key: 'itemName',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.itemName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemModel',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.itemModel',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemUnit',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.itemUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'originalQuantity',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.originalQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyQuantity',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.applyQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applicantNumber',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.applicantNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applicantName',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.applicantName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyDept',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.applyDept',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyDeptManagerNumber',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.applyDeptManagerNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyDeptManagerName',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.applyDeptManagerName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyReason',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.applyReason',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastApplyDate',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.lastApplyDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyStartDate',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.applyStartDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyEndDate',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.applyEndDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyRemark',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.applyRemark',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyAttachmentsList',
        label: 'label.em.ppe.ppeApplyRecordHistory.entity.applyAttachments',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'applyAttachments'
        }
    }
]

export {
    PpeApplyRecordHistory, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
